'use strict';

const MOBILE_STATUS = {
    0x00: 'NO_POWER',
    0x01: 'UNREGISTERED',
    0x02: 'REGISTERED',
    0x03: 'PIN_ERROR'
};

function parse(reader) {
    reader.readUInt8('data.params', value => MOBILE_STATUS[value]);
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_1/common/rule/mobile-status-parser.js